import Image from 'app/Components/Shared/Image/image';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Config from '../../../../../Config';


const LoaderPage = (props) => {


    return (
        <div className="loader-page">
            {props.pageContent.title && <div className='title'> {props.pageContent.title}</div>}
            <Image className='loader-image' src={ Config.epiBaseUrl + props.epiBlockData.loaderImage} alt='loader image' />
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        pageContent: state.localCellularTroubleshootingWizardBlock.pageContent,
        epiBlockData: state.localCellularTroubleshootingWizardBlock.epiBlockData
    };
};

const mapDispatchToProps = { };

export default connect(mapStateToProps, mapDispatchToProps)(LoaderPage);
